
export default class URLUTMGetter
{
    constructor(allowOwnHostReferral = false, cookieExpires = 604800) {
        this.allowOwnHostReferral = allowOwnHostReferral;
        this.cookieExpires = cookieExpires;
    }

    get() {
        const urlParams = new URLSearchParams(window.location.search);
        let utm_source = urlParams.get('utm_source');
        let utm_medium = urlParams.get('utm_medium');
        let utm_campaign = urlParams.get('utm_campaign');
        let utm_content = urlParams.get('utm_content');
        let utm_term = urlParams.get('utm_term');
        let vptapp_utm_creation_date = urlParams.get('vptapp_utm_creation_date');
        let vptapp_referrer = decodeURIComponent(urlParams.get('vptapp_referrer') || '');
        let cookieExpires = this.cookieExpires;

        if (vptapp_utm_creation_date) {
            let creationDate = new Date(vptapp_utm_creation_date);
            const currentDate = new Date();
            if (currentDate < creationDate) {
                creationDate = currentDate;
            }

            const timeDifference = currentDate - creationDate;
            const timeDifferenceInSeconds = Math.floor(timeDifference / 1000);
            cookieExpires -= timeDifferenceInSeconds;
        }

        if (cookieExpires < 0) {
            cookieExpires = this.cookieExpires;
            utm_source = '';
            utm_medium = '';
            utm_campaign = '';
            utm_content = '';
            utm_term = '';
        }

        if (!utm_source && !utm_medium) {
            const ownHost = window.location.host.replace('www.', '');
            let referrer = document.referrer || vptapp_referrer || '';

            if (this.allowOwnHostReferral || !referrer.includes(ownHost)) {
                if (referrer.includes(ownHost)) {
                    referrer = window.location.host;
                }
                
                if (referrer == '' || !referrer) {
                    utm_source = 'direct';
                    utm_medium = window.location.host;
                } else {
                    const searchEngine = this._checkIfIsSearchEngine(referrer);
                    if (searchEngine) {
                        utm_source = searchEngine;
                        utm_medium = 'organic';
                    } else {
                        utm_source = referrer;
                        utm_medium = 'referral';
                    }
                }
            }
        }

        if (this._isExcludedSource(utm_source)) {
            utm_source = '';
            utm_medium = '';
            utm_campaign = '';
            utm_content = '';
            utm_term = '';
        }

        return {
            source: utm_source,
            medium: utm_medium,
            campaign: utm_campaign,
            content: utm_content,
            term: utm_term,
            cookieExpires
        }
    }

    _checkIfIsSearchEngine(referrer) {
        const searchEngines = ['google', 'bing', 'yahoo', 'duckduckgo', 'ecosia', 'qwant', 'baidu', 'yandex', 'search.brave', 'privacywall', 'startpage', 'searchbip', 'petalsearch', 'naver', 'alohafind'];
        return searchEngines.find(engine => referrer.includes(engine));
    }

    _isExcludedSource(source) {
        if (!source) {
            return false;
        }

        const excludedSources = ['redsys', 'banc', 'bank', 'nexigroup', 'revolut', 'arcot', 'pay', 'auth', 'acs', 'bizum', 'sibs', '3ds'];
        return excludedSources.some(excluded => source.toLowerCase().includes(excluded));
    }
}
